'use client';

import React from 'react';
import { Box, Typography, IconButton, Stack, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useAgentContext } from '../../context/AgentContext';

export default function AgentPanelHeader() {
  const { state, closePanel, toggleHistory } = useAgentContext();

  const connectionDotColor =
    state.connectionStatus === 'connected'
      ? '#4ECB71'
      : state.connectionStatus === 'connecting'
        ? '#F5A623'
        : state.connectionStatus === 'error'
          ? '#d0342c'
          : '#6b7785';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '1.25rem',
        py: '0.75rem',
        borderBottom: '1px solid rgba(244, 246, 255, 0.08)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <AutoAwesomeIcon sx={{ color: 'var(--primary-color)', fontSize: '1.25rem' }} />
        <Typography
          variant="h6"
          sx={{
            color: 'var(--sw-white-color)',
            fontSize: '1rem',
            fontWeight: 600,
          }}
        >
          SkyWatch Enterprise Assistant
        </Typography>
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: connectionDotColor,
            ml: 0.5,
          }}
        />
        <Chip
          label="Beta"
          size="small"
          sx={{
            ml: 0.5,
            height: 20,
            fontSize: '0.625rem',
            fontWeight: 700,
            bgcolor: 'rgba(71, 225, 188, 0.15)',
            color: 'var(--primary-color)',
            border: '1px solid rgba(71, 225, 188, 0.3)',
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={0.5}>
        <IconButton
          onClick={toggleHistory}
          size="small"
          sx={{
            color: state.showHistory ? 'var(--primary-color)' : 'var(--sw-white-color-90)',
            '&:hover': { color: 'var(--primary-color)' },
          }}
        >
          <HistoryIcon fontSize="small" />
        </IconButton>
        <IconButton
          onClick={closePanel}
          size="small"
          sx={{
            color: 'var(--sw-white-color-90)',
            '&:hover': { color: 'var(--sw-white-color)' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
}
